module.exports = __webpack_public_path__ + "img/battery.6820b6dd.svg";